<!-- 慈福项目详情 -->
<template>
  <div class="pageView">
    <PCNavbar />
    <CarouselHome type="projectDetail" />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="block flex" style="width: 100%;">
          <div class="left">
            <img :src="detail.image" />
          </div>
          <div class="right">
            <div class="title">{{ detail.title }}</div>
            <div class="desc">{{ detail.jieshao }}</div>
            <div class="p">备案编号：{{ detail.beian_number }}</div>
            <div class="p">项目类型：{{ detail.cate?.title }}</div>
            <div class="p">募捐起止：{{ detail.start_time_text }}--{{ detail.end_time_text }}</div>
            <div class="p">爱心人次：{{ detail.total_paid_count }}</div>
            <div class="p last">已筹金额：</div>
            <div class="money">
              <strong>{{ detail.price }}</strong>
              <span>元</span>
            </div>
            <div class="flex" v-if="detail.status == 1">
              <el-button class="btn" @click="juanzeng">我要捐赠 </el-button>
              <el-button type="text" class="btn-link" @click="openDialog">
                <img class="btn-icon-share" src="@/assets/images/share.svg" />
                <span style="padding-left: 5px;">分享项目</span>
              </el-button>
            </div>
          </div>
        </div>
        <div class="tab">
          <div class="tab-item" :class="{ current: current == 1 }" @click="toggle(1)">项目详情</div>
          <div class="tab-item" :class="{ current: current == 2 }" @click="toggle(2)">捐赠动态</div>
          <div class="tab-item" :class="{ current: current == 3 }" @click="toggle(3)">项目进展</div>
          <div class="tab-item" :class="{ current: current == 4 }" @click="toggle(4)">相关资讯</div>
        </div>
        <div class="article" v-show="current == 1">
          <h3 class="h3">项目描述</h3>
          <div class="content" v-html="detail.desc"></div>
          <h3 class="h3">募捐目的</h3>
          <div class="content">{{ detail.mudi }}</div>
          <h3 class="h3">款项用途</h3>
          <div class="content">{{ detail.yongtu }}</div>
          <h3 class="h3">受益人</h3>
          <div class="content">{{ detail.shouyiren }}</div>
          <h3 class="h3">票据索取</h3>
          <div class="content">{{ detail.piaojusuoqu }}</div>
          <el-link class="btn" href="#/donate/3" :underline="false">申领票据</el-link>
        </div>
        <div class="article" v-show="current == 2">
          <div class="box">
            <div class="yellow">
              <p class="num">{{ detail.total_paid_count }}</p>
              <p class="text">人次参与了爱心捐赠</p>
            </div>
            <div class="list">
              <div class="list-row" v-for="(item, index) in list" :key="index">
                <span class="name">{{ item.name }}</span>
                <span class="tow">
                  <!-- <span class="date">{{ item.pay_time_text }}</span> -->
                  <span class="jiange">{{ item.pay_time }}</span>
                  <span class="date">{{ item.pay_type }}</span>
                </span>
                <span class="money">
                  捐赠
                  <span class="mark">{{ item.price }}</span>
                  元
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="article" v-show="current == 3">
          <div class="box activities">
            <el-timeline v-if="activities.length">
              <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.update_time">
                <div class="title">{{ activity.title }}</div>
                <div class="content kkk" v-html="activity.content"></div>
                <div class="picture" v-if="activity.pics && activity.pics.length > 0">
                  <el-image
                    class="img"
                    v-for="(img, index) in activity.pics.split(',')"
                    :key="index"
                    :src="`${baseURL}${img}`"
                    :preview-src-list="activity.pics.split(',')"
                  />
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="more" v-if="page < lastPage">
            <el-link icon="el-icon-arrow-down" :underline="false" @click="handleNextChange">加载更多</el-link>
          </div>
        </div>
        <div class="article" v-show="current == 4">
          <div class="box">
            <div class="list" v-if="activities.length">
              <div class="list-box" v-for="(item, index) in activities" :key="index" @click="handleToNewsDetails(item)">
                <el-image :src="item.image" class="img" />
                <div class="info">
                  <div class="title">{{ item.title }}</div>
                  <div class="time">{{ item.show_time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="current == 2 || current == 4">
        <el-pagination ref="pagination" layout="slot" :total="total" :current-page="page" hide-on-single-page>
          <div style="display: flex;justify-content: center;">
            <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
              <i class="el-icon-arrow-left"></i>
              上一页
            </el-button>
            <el-pagination
              layout="pager"
              :current-page="page"
              :pager-count="11"
              @current-change="handleCurrentChange"
              :page-size="20"
              :total="total">
            </el-pagination>
            <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
              下一页
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="324px" center append-to-body top="30vh" :show-close="false" :custom-class="'custom-dialog'">
      <div class="dialog">
        <div class="dialog-popup">
          <el-image style="width: 120px; height: 120px" :src="detail.qrcode"  class="imagebLock"/>
          <div class="dialog-title">分享项目</div>
          <div class="dialog-content">请使用微信“扫一扫”，进入项目页面</div>
        </div>
        <i class="el-icon-circle-close" @click="dialogVisible = false" />
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogJuanVisible" width="324px" center append-to-body top="30vh" :show-close="false" :custom-class="'custom-dialog'">
      <div class="dialog">
        <div class="dialog-popup">
          <el-image style="width: 120px; height: 120px" :src="detail.qrcode"  class="imagebLock"/>
          <div class="dialog-title">捐赠项目</div>
          <div class="dialog-content">请使用微信“扫一扫”，进入项目页面</div>
        </div>
        <i class="el-icon-circle-close" @click="dialogJuanVisible = false" />
      </div>
    </el-dialog>
    <Footer />
  </div>
</template>


<script>
import CifuAPI from "@/utils/api";
import { baseURL } from "@/utils/http";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";
import { smartDesensitize, formatDate, formatPast } from "@/utils/tools";

export default {
  name: "Project",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      id: this.$route.query.id,
      baseURL,
      current: 1,
      detail: {},
      list: [],
      page: 1,
      lastPage: 1,
      total: 0,
      activities: [],
      dialogVisible: false,
      dialogJuanVisible: false
    };
  },
  created() {
    this.current = this.$route.query.type || 1;
    this.getDetail();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    toggle(index) {
      this.current = index;
      if (index == 1) {
        this.getDetail();
      } else if (index == 2) {
        this.getList();
      } else if (index == 3) {
        this.getActivities("project_jinzhan");
      } else if (index == 4) {
        this.getActivities("project_zixun");
      }
      this.$store.dispatch("setMenuActive", "/projectDetail?type=" + index);
      // 更新路由参数
      this.$router.replace({
        path: "/projectDetail",
        query: { ...this.$route.query, type: index },
      });
    },
    async getDetail() {
      let res = await CifuAPI.getProjectDetail({ id: this.id });
      if (res.code == 1) {
        this.detail = res.data;
      }
    },
    async getList() {
      let res = await CifuAPI.getDonateList({
        project_id: this.id,
        is_mylog: 0,
        page: this.page,
        limit: 20
      });
      if (res.code == 1) {
        res.data.data.map((item) => {
          item.name = smartDesensitize(item.name);
          item.pay_time_text = formatDate(item.pay_time_text, "YYYY.MM.DD");
          item.pay_time = formatPast(item.pay_time * 1000);
        });
        this.lastPage = res.data.last_page;
        this.total = res.data.total;
        this.list = res.data.data;
      }
    },
    async getActivities(type) {
      const res = await CifuAPI.getArticleList({ project_id: this.id, model_type: type, page: this.page });
      if (res.code == 1) {
        this.activities = res.data.data;
        this.lastPage = res.data.last_page;
        this.total = res.data.total;
      }
    },
    handlePrevChange() {
      const index = this.current;
      this.page--;
      this.toggle(index);
    },
    handleCurrentChange(e) {
      const index = this.current;
      this.page = e;
      this.toggle(index);
    },
    handleNextChange() {
      const index = this.current;
      this.page++;
      this.toggle(index);
    },
    handleToNewsDetails(item) {
      if (item.gzh_url) {
        window.open(item.gzh_url, 'blank')
      } else {
        const targetRoute = this.$router.resolve({
          name: 'DonateDetail',
          query: { id: item.id },
        });
        window.open(targetRoute.href, '_blank');
      }
    },
    openDialog() {
      this.dialogVisible = true;
    },
    juanzeng() {
      this.dialogJuanVisible = true
    },
  },
};
</script>

<style lang="scss" scoped>
.article {
  .box {
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px 0;
    }
  }
}
.main-wrap {
  position: relative;
  z-index: 2;
  margin-top: -174px;
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   margin-top: 20px;
  // }
  .block {
    padding: 0;
    .left {
      width: 558px;
      height: 528px;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   display: none;
      // }
      img {
        width: 558px;
        height: 512px;
        vertical-align: top;
      }
    }
    .right {
      padding-left: 50px;
      padding-right: 50px;
      padding-bottom: 40px;
      padding-top: 56px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        flex: 1;
        padding: 20px;
      }
    }
    .title {
      width: 100%;
      font-size: 48px;
      color: #663301;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        height: auto;
        font-size: 16px;
      }
    }
    .desc {
      padding-bottom: 20px;
      font-size: 18px;
      color: #4f4f4f;
      line-height: 26px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 12px;
      }
    }
    .p {
      font-size: 18px;
      color: #828282;
      line-height: 30px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 12px;
      }
    }
    .last {
      padding-top: 48px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        padding-top: 24px;
      }
    }
    .money {
      height: 78px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        height: auto;
      }
      strong {
        font-size: 56px;
        color: #663301;
        font-weight: bold;
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          font-size: 32px;
        }
      }
      span {
        line-height: 90px;
        margin-left: 6px;
        font-size: 18px;
        color: #828282;
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          line-height: 32px;
          font-size: 14px;
        }
      }
    }
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      .btn-icon-share {
        width: 16px;
        height: 16px;
      }
    }
  }
  .tab {
    margin-top: 60px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      margin-top: 20px;
    }
  }
}
.dialog {
  padding-top: 13px;
  text-align: center;
  &-title {
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 20px;
    color: #663301;
  }
  &-content {
    font-size: 16px;
    color: #757575;
  }
  .el-icon-circle-close {
    position: absolute;
    top: 108%;
    left: calc(50% - 24px);
    font-size: 48px;
    color: #fff;
    cursor: pointer;
  }
}
  // .article img,
  // .content img,
::v-deep .article > img{
  width: 100% !important; 
}
::v-deep .content > img{
  width: 100% !important; 
}
::v-deep .content > p {
  line-height: 0 !important;
}
::v-deep .btn-link>span{
  display: flex !important;
}
::v-deep .el-image__inner{
  width: 100% !important;
  height: 100% !important
}
.yellow{
  width: 100%;
  padding: 20px;
  background-color: #fbce00;
  text-align: center;
  color: #663301;
  .num {
    line-height: 42px;
    font-weight: 900;
    font-size: 40px;
  }
  .text {
    line-height: 19px;
    font-weight: bold;
    font-size: 16px;
  }
}
.list{
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  padding-top: 10px;
}
.list-row{
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 0 !important;
  border-bottom: 1px solid #e0e0e0;
}
::v-deep .kkk>p {
  line-height: 30px !important;
}
::v-deep .el-pager{
  li{
    background: #f5f5f5 !important;
    font-size: 18px;
    color: #999;
  }
  .active{
    color: #663301;
  }
}
</style>
